// extracted by mini-css-extract-plugin
export var copy = "NewsletterSignup-module--copy--3b61m";
export var emailField = "NewsletterSignup-module--emailField--qSVpJ";
export var wrapper = "NewsletterSignup-module--wrapper--1qjDB";
export var inner = "NewsletterSignup-module--inner--oi9SW";